import { Navigate } from 'react-router-dom';
import { useAppSelector } from './redux/hooks';
import { selectIsLoggedIn, selectUserLoading } from './redux/slices/user';

const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const isLoading = useAppSelector(selectUserLoading); // <-- add this in your slice

    if (isLoading) {
        // while checking auth, don’t redirect yet
        return <div>Loading...</div>; // or a spinner
    }

    return isLoggedIn ? element : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
